"use strict";
import { addEvent } from "../addEvent/addEvent";

export const mobileMenu = class {
  bodyClassName = "mobile-menu";
  bodyMobileMenuShowClassName = "mobile-menu-show";
  mobileMenuButtonClassName = "menu-button";
  mobileMenuContainerClassName = "full-site-menu-container";
  mobileMenuScrollContainerClassName = "full-site-menu";

  nav = false;
  body = false;
  menuList = false;
  mobileMenuContainer = false;
  mobileMenuButton = false;
  mobileMenuButtonContainer = false;
  mobileShow = false;

  constructor() {
    let nav = document.getElementsByClassName("header__top-nav")[0];
    if (!nav) return;
    let nav2 = document.getElementsByClassName("main-nav")[0];
    this.nav = [nav, nav2];
    // utwórz nową pustą listę <ul>
    let combinedList = document.createElement("ul");

    [this.getTopLevelULs(nav), this.getTopLevelULs(nav2)].forEach(uls => {
      uls.forEach(ul => {
        // pobieramy tylko bezpośrednie <li> (ul.children zawiera tylko bezpośrednie dzieci)
        Array.from(ul.children).forEach(child => {
          if (child.tagName && child.tagName.toLowerCase() === 'li') {
            // deep clone — zachowuje wszelkie zagnieżdżone <ul> wewnątrz <li>
            combinedList.appendChild(child.cloneNode(true));
          }
        });
      });
    });

    this.menuList = combinedList;
    this.body = document.getElementsByTagName("body")[0];
    this.mobileMenuButtonContainer = document.getElementsByClassName(
      "header__menu-container"
    )[0];
    this.test();
    addEvent(window, "resize", () => {
      this.test();
    });
    return this;
  }

  test = () => {
    const { enabled, disabled } = this;

    const breakPoint = 1400;
    const widthWin = $(window).width();

    if (breakPoint > widthWin) {
      enabled();
      // console.log("enabled");
    } else {
      disabled();
      // console.log("disabled");
    }
  };

  getTopLevelULs = (container) => {
    if (!container) return [];
    // najlepszy sposób: :scope > ul (tylko bezpośrednie <ul> będące dziećmi kontenera)
    let uls = container.querySelectorAll(':scope > ul');
    if (uls.length) return Array.from(uls);
    // fallback dla przeglądarek bez :scope — sprawdź bezpośrednie dzieci
    return Array.from(container.children).filter(node => node.tagName && node.tagName.toLowerCase() === 'ul');
  }

  enabled = () => {
    const { body, bodyClassName, _createMenuButton, _cereateMenuContainer } =
      this;
    body.classList.add(bodyClassName);
    _createMenuButton();
    _cereateMenuContainer();
  };

  disabled = () => {
    const { body, bodyClassName, _removeMenuButton, _remveMenuContainer } =
      this;
    body.classList.remove(bodyClassName);
    _removeMenuButton();
    _remveMenuContainer();
  };

  _cereateMenuContainer = () => {
    const {
      nav,
      body,
      mobileMenuContainerClassName,
      mobileMenuButtonContainer,
      mobileMenuScrollContainerClassName,
      menuList,
    } = this;

    if (this.mobileMenuContainer) return;

    let mobileMenuContainer = document.createElement("div");
    mobileMenuContainer.classList.add(mobileMenuContainerClassName);

    let mobileMenuScrollContainer = document.createElement("div");
    mobileMenuScrollContainer.classList.add(mobileMenuScrollContainerClassName);

    mobileMenuScrollContainer.appendChild(menuList);
    mobileMenuContainer.appendChild(mobileMenuScrollContainer);

    this.mobileMenuContainer =
      mobileMenuButtonContainer.appendChild(mobileMenuContainer);
  };

  _remveMenuContainer = () => {
    if (!this.mobileMenuContainer) return;

    this.mobileMenuContainer.remove();
    this.mobileMenuContainer = false;
  };

  _createMenuButton = () => {
    const {
      body,
      nav,
      mobileMenuButtonContainer,
      mobileMenuButtonClassName,
      bodyMobileMenuShowClassName,
    } = this;
    if (this.mobileMenuButton) return;

    let div = document.createElement("div");
    let span = document.createElement("span");
    let span2 = document.createElement("span");
    let span3 = document.createElement("span");
    div.appendChild(span);
    div.appendChild(span2);
    div.appendChild(span3);

    let mobileButton = document.createElement("div");
    mobileButton.classList.add(mobileMenuButtonClassName);

    mobileButton.appendChild(div);

    this.mobileMenuButton = mobileMenuButtonContainer.appendChild(mobileButton);

    addEvent(this.mobileMenuButton, "click", (e) => {
      e.preventDefault();
      if (this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
      } else {
        body.classList.add(bodyMobileMenuShowClassName);
        this.mobileShow = true;
      }
    });

    addEvent(document, "keyup", (e) => {
      if (e.keyCode == 27 && this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
      }
    });
  };

  _removeMenuButton = () => {
    if (!this.mobileMenuButton) return;

    this.mobileMenuButton.remove();
    this.mobileMenuButton = false;
  };
};
